import React, { useState, useEffect } from "react";
import "../styles/DarkMode.css";

function DarkMode() {
  const [theme, setTheme] = useState("light");
  const [toggle, setToggle] = useState(false);
  const clickedClass = "clicked";
  const body = document.body;
  const lightTheme = "light";
  const darkTheme = "dark";

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      setTheme(savedTheme);
    } else {
      setTheme(lightTheme);
    }
  }, []);

  useEffect(() => {
    body.classList.remove(lightTheme, darkTheme);
    body.classList.add(theme);
  }, [theme]);

  const switchTheme = () => {
    if (theme === darkTheme) {
      localStorage.setItem("theme", lightTheme);
      setTheme(lightTheme);
    } else {
      localStorage.setItem("theme", darkTheme);
      setTheme(darkTheme);
    }
    setToggle(!toggle);
  };

  return (
    <button
      className={theme === darkTheme ? clickedClass : ""}
      id="darkMode"
      onClick={switchTheme}
    ></button>
  );
}

export default DarkMode;
